import { composeValidators, validate } from '@alfa-bank/site-helpers-form/validation/utils';
import { validateNotEmpty } from '@alfa-bank/site-helpers-form/validation/not-empty';
import type { TValidatorValue } from '@alfa-bank/site-helpers-form/src/validation/models';
import { DEFAULT_PHONE_MESSAGE } from '@alfa-bank/site-helpers-form/validation/phone';
import { isValidAlfaPhone } from '@alfa-bank/site-helpers-form/validation/alfa-phone';

const validateAlfaPhoneValue = (value: TValidatorValue) =>
    validate(isValidAlfaPhone(value), DEFAULT_PHONE_MESSAGE);

export const validate79 = (value: string) =>
    validate(
        /^\+7 \(9/.test(value),
        DEFAULT_PHONE_MESSAGE,
        'Телефон указан неверно. Некорректный\u00A0код\u00A0оператора'
    );

export const validatePhone = () =>
    composeValidators(validateNotEmpty(), validateAlfaPhoneValue, validate79);
